/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { ToggleButton } from '@veeam/components';
import styled, { css } from 'styled-components';

const BASIC_FILTER_TOGGLE_BUTTON_Z_INDEX_DEFAULT = 1;

export const StyledToggleButton = styled(ToggleButton)`
    position: relative; // to be able change z-index

    ${({ isToggled, disabled }) =>
        isToggled && !disabled
            ? css`
                  z-index: ${BASIC_FILTER_TOGGLE_BUTTON_Z_INDEX_DEFAULT + 1};
              `
            : css`
                  z-index: ${BASIC_FILTER_TOGGLE_BUTTON_Z_INDEX_DEFAULT};
              `}
`;
